import request from '@/utils/request'

// 累计支付充值等
export function indexStatics() {
  return request({ url: '/webapi/index/indexStatics', method: 'get' })
}

// 获取某月支付异常日期
export function getAbnormalInfo(params) {
  return request({ url: '/webapi/index/getAbnormalInfo', method: 'get', params })
}

// 年月日图表
export function payStatics(params) {
  return request({ url: '/webapi/index/payStatics', method: 'get', params })
}

// 首页预警用户列表
export function getWarnOpenIds(params) {
  return request({ url: '/webapi/index/getWarnOpenIds', method: 'get', params })
}

// 预警用户身份认证
export function verifyOpenId(data) {
  return request({ url: '/webapi/index/verifyOpenId', method: 'post', data })
}

// 预警导出
export function exportWarnOpenIds(data) {
  return request({ url: '/webapi/index/exportWarnOpenIds', method: 'post', data, responseType: 'blob' })
}

